function initialValues() {
  return {
    currentPassword: '',
    password: '',
  };
}

export default initialValues;
